export default "__VITE_ASSET__BBmb$Xzc__"